import * as React from "react";
import Button, { type ButtonProps } from "./Button";

interface Props extends ButtonProps {
    floating?: boolean;
}

export default class PrimaryButton extends React.Component<Props> {
    public render(): React.ReactNode {
        const {
            floating,
            onClick,
            classes: parentClasses,
            ...otherProps
        } = this.props;

        const classes = [ "button-primary" ];

        if(floating) {
            classes.push("floating");
        }

        if(Array.isArray(parentClasses)) {
            classes.push(...parentClasses);
        }

        return (
            <Button
                onClick={onClick}
                type="button"
                classes={classes}
                {...otherProps}
            >
                {this.props.children}
            </Button>
        );
    }
}
